'use client'

import { isNull } from 'lodash-es'
import { ComponentProps, useEffect, useState } from 'react'

import { LikeButton } from '@/features/toggle-favorite-room'
import { CopyButton } from '@/shared/lib'
import { Icon, Sheet } from '@/shared/ui'

type Props = ComponentProps<'div'> & {
  roomId: number
  like: boolean
  showLikeButton?: boolean
  roomUrl: string | null
}

export const Header = ({
  roomId,
  like,
  showLikeButton = true,
  roomUrl,
  ref,
  ...restProps
}: Props) => {
  const hasRoomUrl = !isNull(roomUrl)

  const [currentUrl, setCurrentUrl] = useState('')

  const url =
    process.env.NEXT_PUBLIC_ENVIRONMENT === 'local' ? currentUrl : roomUrl

  useEffect(() => {
    setCurrentUrl(window.location.href)
  }, [])

  return (
    <Sheet.Header
      className="h-14 flex-row justify-between bg-white px-5 py-3"
      ref={ref}
      {...restProps}
    >
      <Sheet.Close asChild>
        <button className="flex w-fit cursor-pointer items-center justify-center p-1">
          <Icon
            name="arrowbar-left"
            size={24}
            strokeWidth={1.5}
            className="text-black"
          />
          <span className="sr-only">이전으로 돌아가기</span>
        </button>
      </Sheet.Close>
      <Sheet.Title className="sr-only">이미지 갤러리</Sheet.Title>
      <div className="flex gap-1">
        {hasRoomUrl && (
          <CopyButton
            asChild
            value={url ?? ''}
            successMessage="링크가 복사되었습니다"
          >
            <button type="button" className="cursor-pointer p-1">
              <Icon
                name="share"
                size={24}
                strokeWidth={1.5}
                className="text-black"
              />
              <span className="sr-only">공유하기</span>
            </button>
          </CopyButton>
        )}
        {showLikeButton && (
          <LikeButton
            variant="line"
            roomId={roomId}
            like={like}
            className="h-8 w-8 p-1"
          />
        )}
      </div>
    </Sheet.Header>
  )
}
